import { cn } from "@/lib/utils";
import { memo } from "react";

interface LoadingSkeletonProps {
  count?: number;
  displayMode?: "grid" | "list";
  isCompact?: boolean;
}

export const LoadingSkeleton = memo(
  ({
    count = 6,
    displayMode = "grid",
    isCompact = false,
  }: LoadingSkeletonProps) => {
    return (
      <div
        className={cn(
          "w-full",
          displayMode === "grid"
            ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
            : "flex flex-col gap-4"
        )}
      >
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className={cn(
              "bg-card rounded-lg overflow-hidden",
              displayMode === "grid"
                ? isCompact
                  ? "h-[280px]"
                  : "h-[320px]"
                : isCompact
                ? "h-[120px]"
                : "h-[160px]"
            )}
          >
            {/* Image skeleton */}
            <div className="w-full h-1/2 bg-muted animate-pulse" />

            {/* Content skeleton */}
            <div className="p-4 space-y-3">
              <div className="h-4 w-3/4 bg-muted rounded animate-pulse" />
              <div className="h-4 w-1/2 bg-muted rounded animate-pulse" />
              <div className="h-4 w-2/3 bg-muted rounded animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    );
  }
);
